"use strict";
import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Close } from "@sumup-oss/icons";
import { IconButton } from "../Button/IconButton.js";
const CloseButton = forwardRef(
  ({ label = "Close", children = label, ...props }, ref) => /* @__PURE__ */ jsx(
    IconButton,
    {
      type: "button",
      variant: "tertiary",
      ...props,
      icon: Close,
      ref,
      children
    }
  )
);
CloseButton.displayName = "CloseButton";
export {
  CloseButton
};
